import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _01bbe3f8 = () => interopDefault(import('..\\pages\\enroll-complete.vue' /* webpackChunkName: "pages/enroll-complete" */))
const _5022cb80 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages/error" */))
const _43b26606 = () => interopDefault(import('..\\pages\\forgot-password.vue' /* webpackChunkName: "pages/forgot-password" */))
const _746a5c0f = () => interopDefault(import('..\\pages\\landing.vue' /* webpackChunkName: "pages/landing" */))
const _10c98ac9 = () => interopDefault(import('..\\pages\\not-eligible.vue' /* webpackChunkName: "pages/not-eligible" */))
const _52e25737 = () => interopDefault(import('..\\pages\\pharmacy\\index.vue' /* webpackChunkName: "pages/pharmacy/index" */))
const _1e56e0db = () => interopDefault(import('..\\pages\\register.vue' /* webpackChunkName: "pages/register" */))
const _3ff29904 = () => interopDefault(import('..\\pages\\selection.vue' /* webpackChunkName: "pages/selection" */))
const _2747fb76 = () => interopDefault(import('..\\pages\\terms-conditions.vue' /* webpackChunkName: "pages/terms-conditions" */))
const _221720fc = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages/unlock" */))
const _d6431104 = () => interopDefault(import('..\\pages\\account\\reset-password.vue' /* webpackChunkName: "pages/account/reset-password" */))
const _469db6fe = () => interopDefault(import('..\\pages\\enrollment\\eligibility.vue' /* webpackChunkName: "pages/enrollment/eligibility" */))
const _79b4bba5 = () => interopDefault(import('..\\pages\\enrollment\\patient-authorization.vue' /* webpackChunkName: "pages/enrollment/patient-authorization" */))
const _424c1850 = () => interopDefault(import('..\\pages\\enrollment\\patient-information.vue' /* webpackChunkName: "pages/enrollment/patient-information" */))
const _7e0c7c40 = () => interopDefault(import('..\\pages\\enrollment\\prescriber-information.vue' /* webpackChunkName: "pages/enrollment/prescriber-information" */))
const _54659406 = () => interopDefault(import('..\\pages\\enrollment\\rejection.vue' /* webpackChunkName: "pages/enrollment/rejection" */))
const _6f88b812 = () => interopDefault(import('..\\pages\\enrollment\\success.vue' /* webpackChunkName: "pages/enrollment/success" */))
const _0b296221 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages/errors/400" */))
const _0b3779a2 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages/errors/401" */))
const _0b53a8a4 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages/errors/403" */))
const _0b61c025 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages/errors/404" */))
const _400f9d62 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages/errors/500" */))
const _04cce3a0 = () => interopDefault(import('..\\pages\\patient\\patientSearch.vue' /* webpackChunkName: "pages/patient/patientSearch" */))
const _0e08e21c = () => interopDefault(import('..\\pages\\patient\\rejection.vue' /* webpackChunkName: "pages/patient/rejection" */))
const _a2338d0e = () => interopDefault(import('..\\pages\\pharmacy\\dashboard.vue' /* webpackChunkName: "pages/pharmacy/dashboard" */))
const _bd9fa29c = () => interopDefault(import('..\\pages\\pharmacy\\eligibility.vue' /* webpackChunkName: "pages/pharmacy/eligibility" */))
const _61e65134 = () => interopDefault(import('..\\pages\\provider\\eligibility.vue' /* webpackChunkName: "pages/provider/eligibility" */))
const _640684ea = () => interopDefault(import('..\\pages\\provider\\patient-information.vue' /* webpackChunkName: "pages/provider/patient-information" */))
const _440aba47 = () => interopDefault(import('..\\pages\\provider\\patient-information-rejection.vue' /* webpackChunkName: "pages/provider/patient-information-rejection" */))
const _1bbbf370 = () => interopDefault(import('..\\pages\\provider\\rejection.vue' /* webpackChunkName: "pages/provider/rejection" */))
const _0d91222a = () => interopDefault(import('..\\pages\\provider\\success.vue' /* webpackChunkName: "pages/provider/success" */))
const _0c5cad4a = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '#{BasePath}#/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/enroll-complete",
    component: _01bbe3f8,
    name: "enroll-complete"
  }, {
    path: "/error",
    component: _5022cb80,
    name: "error"
  }, {
    path: "/forgot-password",
    component: _43b26606,
    name: "forgot-password"
  }, {
    path: "/landing",
    component: _746a5c0f,
    name: "landing"
  }, {
    path: "/not-eligible",
    component: _10c98ac9,
    name: "not-eligible"
  }, {
    path: "/pharmacy",
    component: _52e25737,
    name: "pharmacy"
  }, {
    path: "/register",
    component: _1e56e0db,
    name: "register"
  }, {
    path: "/selection",
    component: _3ff29904,
    name: "selection"
  }, {
    path: "/terms-conditions",
    component: _2747fb76,
    name: "terms-conditions"
  }, {
    path: "/unlock",
    component: _221720fc,
    name: "unlock"
  }, {
    path: "/account/reset-password",
    component: _d6431104,
    name: "account-reset-password"
  }, {
    path: "/enrollment/eligibility",
    component: _469db6fe,
    name: "enrollment-eligibility"
  }, {
    path: "/enrollment/patient-authorization",
    component: _79b4bba5,
    name: "enrollment-patient-authorization"
  }, {
    path: "/enrollment/patient-information",
    component: _424c1850,
    name: "enrollment-patient-information"
  }, {
    path: "/enrollment/prescriber-information",
    component: _7e0c7c40,
    name: "enrollment-prescriber-information"
  }, {
    path: "/enrollment/rejection",
    component: _54659406,
    name: "enrollment-rejection"
  }, {
    path: "/enrollment/success",
    component: _6f88b812,
    name: "enrollment-success"
  }, {
    path: "/errors/400",
    component: _0b296221,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _0b3779a2,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _0b53a8a4,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _0b61c025,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _400f9d62,
    name: "errors-500"
  }, {
    path: "/patient/patientSearch",
    component: _04cce3a0,
    name: "patient-patientSearch"
  }, {
    path: "/patient/rejection",
    component: _0e08e21c,
    name: "patient-rejection"
  }, {
    path: "/pharmacy/dashboard",
    component: _a2338d0e,
    name: "pharmacy-dashboard"
  }, {
    path: "/pharmacy/eligibility",
    component: _bd9fa29c,
    name: "pharmacy-eligibility"
  }, {
    path: "/provider/eligibility",
    component: _61e65134,
    name: "provider-eligibility"
  }, {
    path: "/provider/patient-information",
    component: _640684ea,
    name: "provider-patient-information"
  }, {
    path: "/provider/patient-information-rejection",
    component: _440aba47,
    name: "provider-patient-information-rejection"
  }, {
    path: "/provider/rejection",
    component: _1bbbf370,
    name: "provider-rejection"
  }, {
    path: "/provider/success",
    component: _0d91222a,
    name: "provider-success"
  }, {
    path: "/",
    component: _0c5cad4a,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
